import config from '~/config';

let cachedData = null;

export const fetchInfo = async () => {
    if (cachedData) {
        return cachedData; 
    }

    try {
        const response = await fetch(`${config.MAIN_API}/api/config/info`, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
        const res = await response.json();

        if (res.status) {
            cachedData = res;
            return res;
        }

        return null;
    } catch (error) {
        console.error('Error fetching info:', error);
        return null;
    }
};
